// extracted by mini-css-extract-plugin
export var childrenContainer = "_4h-0";
export var virtualScrollArea = "_4h-1";